let now = new Date();

let lastMonth = now.getMonth() == 0 ? 11 : now.getMonth() - 1;
lastMonth = (lastMonth + 1 > 9 ? "" : "0") + (lastMonth + 1)

let lastYear = lastMonth == 12 ? now.getFullYear() - 1 : now.getFullYear();

let a = new Date();
a.setDate(0);
let lastMaxDay = a.getDate();

//当月最后一天
let enddate = new Date(now.getFullYear(), now.getMonth() + 1, 0)
var newTime=enddate.getDate()


let nowMonth=(now.getMonth() + 1 > 9 ? "" : "0") + (now.getMonth() + 1);

let nextMonth = now.getMonth() + 1
let nextYear = now.getFullYear()
nextMonth = (nextMonth < 9 ? "0" : "") + (nextMonth + 1);

if(nextMonth == 13){
  nextMonth = "01"
  nextYear = nextYear + 1
}

var preSize = new Date(nextYear, parseInt(nowMonth) - 1, 0).getDate(); //上月总天数
var nextSize = new Date(nextYear, parseInt(nowMonth) + 1, 0).getDate(); //下月总天数

/* if (preSize < parseInt(lastMaxDay) ) {
  // 取上个月，如果上个月总天数小于本月今天，取上个月最后一天
 nextYear + "-" + lastMonth + "-" + preSize;
} else if (nextSize < parseInt(lastMaxDay) ) {
  // 如果下个月总天数小于本月今天，取下个月最后一天
  // var x = nextYear + "-" + nextMonth + "-" + nextSize;
}
 */

let hour = now.getHours() // 获取小时
let minutes = now.getMinutes() // 获取分钟
let second = now.getSeconds() // 获取秒

if (hour >= 0 && hour <= 9) {
   hour = "0" + hour;
}
if (minutes >= 0 && minutes <= 9) {
  minutes = "0" + minutes;
}
if (second >= 0 && second <= 9) {
  second = "0" + second;
}

// 当月当天
let nowDate=now.getFullYear()+"-"+nowMonth+"-"+(now.getDate()> 9 ? "" : "0")+now.getDate()+' '+hour+':'+minutes+':'+second;
// 上月当天
let lastDate = lastYear + "-" + lastMonth + "-" + (now.getDate() > lastMaxDay ?  (lastMaxDay > 9 ? "" : "0")+lastMaxDay : (now.getDate() > 9 ? "" : "0")+now.getDate())+" 00:00:00";
// 下月当天
let nextDate = nextYear + "-" + nextMonth + "-" + (now.getDate() > nextSize ?  (lastMaxDay >9 ? "" : "0")+nextSize : (now.getDate() > 9 ? "" : "0")+now.getDate())+" 00:00:00";
// 当月当天 时间 00：00：00
let nowDates=now.getFullYear()+"-"+nowMonth+"-"+(now.getDate()> 9 ? "" : "0")+now.getDate()+' 00:00:00';
// 当月第一天
let firstDay = now.getFullYear()+"-"+nowMonth+"-"+'01 00:00:00';
// 当月最后一天
let lastDay = now.getFullYear()+"-"+nowMonth+"-"+newTime+' 00:00:00';

// 数量 打印条码
let NUM = 100
let supplierCode = 'A001'
// JSON.parse(sessionStorage.getItem('user')).supplier.Supplier_Code
export default{
  lastDate,
  nowDate,
  NUM,
  nextDate,
  nowDates,
  firstDay,
  lastDay,
  supplierCode
}



// WEBPACK FOOTER //
// ./src/util/date.js